import { ITee } from '../admin/courses/store';

export interface IRoundTeesAssignation {
  ageLower: number | null;
  ageUpper: number | null;
  gender: string | null;
  handicapLower: number | null;
  flight?: number | null;
  handicapUpper: number | null;
  id: number;
  round: number;
  tee: ITee | undefined;
}

export interface IRoundTeesStore {
  assignation: IRoundTeesAssignation[];
}

export const roundTeesStore = {
  assignation: []
};
